import { render, staticRenderFns } from "./LookPromtion.vue?vue&type=template&id=760215be&scoped=true&"
import script from "./LookPromtion.vue?vue&type=script&lang=js&"
export * from "./LookPromtion.vue?vue&type=script&lang=js&"
import style0 from "./LookPromtion.vue?vue&type=style&index=0&id=760215be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760215be",
  null
  
)

export default component.exports